import { Button } from "../ui/button";
import { useNavigate } from "@tanstack/react-router";
import { useTenantPath } from "~/hooks/use-tenant-path";

type NoApplicationsProps = {
  isCollaboratedView?: boolean;
};

const NoApplications = ({ isCollaboratedView = false }: NoApplicationsProps) => {
  const navigate = useNavigate();
  const tenantPath = useTenantPath();

  // For collaborations view, show a simple message without box/button
  if (isCollaboratedView) {
    return (
      <></>
    );
  }

  return (
    <div className="text-center py-20 bg-gray-50">
      <div className="max-w-md mx-auto">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-8 h-8 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          No applications yet
        </h3>
        <p className="text-sm ">
          Get started by creating your first certification application
        </p>
        <Button
          className="mt-4"
          onClick={() =>
            navigate({
              to: tenantPath("/apply/$applicationId"),
              params: { applicationId: "new" },
            })
          }
        >
          + New Application
        </Button>
      </div>
    </div>
  );
};
export default NoApplications;
